export default function toTimeOnly(datestring) {

  if (!datestring) return "";

  const date = new Date(datestring);

  // Format hours and minutes with leading zeros
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;

    // // let start = new Date(datestring);      
    // // let startTime = start.toUTCString().split(' '); 
    // // startTime = startTime[startTime.length-2].split(':'); 
    // // startTime = startTime[0]+':'+startTime[2];
        
    // // return (startTime) 

    // //let timeVar = new Date(datestring).toLocaleTimeString(); 

    // let startTime = new Date(datestring).toUTCString().split(' '); startTime = startTime[startTime.length-2]; startTime = (startTime === '00:00:00') ? '' : startTime;
    // let startTime1 = startTime.split(':');
    // startTime = startTime1.slice(0,1)+':'+startTime1.slice(1,2);

    // let timeVar = new Date(datestring).toUTCString(); 
    // let timeVar1 = timeVar.split(':')
    // timeVar = timeVar1.slice(0,1)+':'+timeVar1.slice(1,2);

    // return (startTime)

}